import { GROUP_TYPES } from "../types/dist/constants.js";
import { Type } from "js-yaml";
class ParsedHeader {
  title;
  type = GROUP_TYPES.header;
  description;
  icon;
  constructor(raw) {
    this.title = raw.title || "";
    this.description = raw.description;
    this.icon = raw.icon;
  }
}
const HeaderTag = new Type("!header", {
  kind: "mapping",
  resolve: (data) => data !== null && data instanceof Object && data.title !== null,
  construct: (textData) => new ParsedHeader(textData || {}),
  instanceOf: ParsedHeader,
  represent: (data) => {
    const header = data;
    return {
      title: header.title,
      ...header.description !== void 0 && { description: header.description },
      ...header.icon !== void 0 && { icon: header.icon }
    };
  }
});
export {
  HeaderTag,
  ParsedHeader
};
